document.addEventListener("DOMContentLoaded", function () {
  const loadMoreButton = document.querySelector("[data-load-more]");
  if (!loadMoreButton) return;

  loadMoreButton.addEventListener("click", function (e) {
    e.preventDefault();
    const url = this.href;
    this.textContent = "Cargando...";
    this.classList.add("loading");

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        const newArticles = doc.getElementById("blog-articles-grid").innerHTML;
        document
          .getElementById("blog-articles-grid")
          .insertAdjacentHTML("beforeend", newArticles);

        const newButtonContainer = doc.getElementById(
          "load-more-button-container"
        );
        const currentButtonContainer = document.getElementById(
          "load-more-button-container"
        );

        if (newButtonContainer) {
          currentButtonContainer.innerHTML = newButtonContainer.innerHTML;
          // Re-attach event listener to the new button
          document
            .querySelector("[data-load-more]")
            .addEventListener("click", arguments.callee);
        } else {
          currentButtonContainer.remove();
        }
      })
      .catch(console.error);
  });
});
